/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React, { useRef } from 'react';
import './CardSelectorPopUp.scss';
import data from './PopUpContent.json';

const CardSelectorPopUp = ({
    handlePopUp, applyOnlineLink, applyNetbankLink,
}) => {
    const modalRef = useRef();

    return (
        <div id="myModal" data-testid="modal-pop-up" className="modal-pop-up" ref={modalRef} onClick={(e) => { if (e.target === modalRef.current) { handlePopUp(); } }}>
            <div className="modal-pop-up-content">
                <button aria-label="Close" data-testid="modal-pop-up-close" className="modal-pop-up-close" type="button" onClick={() => handlePopUp()}>
                    <span aria-hidden="true">{data?.popUpText?.closeLabel}</span>
                </button>

                <div className="modal-pop-up-container-1">
                    <h2 className="modal-pop-up-h2">{data?.popUpText?.exixtingToBankHeader}</h2>
                    <p>{data?.popUpText?.existingToBankSubText}</p>
                    <a className="modal-pop-up-button" id="apply-online-etb" href={applyNetbankLink} target="_blank" rel="noreferrer">{data?.popUpText?.existingToBankButtonLabel}</a>
                </div>

                <p className="modal-pop-up-or-position">{data?.popUpText?.orLabel}</p>

                <div className="modal-pop-up-container-2">
                    <h2 className="modal-pop-up-h2">{data?.popUpText?.newToBankHeader}</h2>
                    <a className="modal-pop-up-button" id="apply-online-ntb" href={applyOnlineLink} target="_blank" rel="noreferrer">{data?.popUpText?.newToBankButtonLabel}</a>
                </div>
            </div>
        </div>
    );
};
export default CardSelectorPopUp;
